import { useState, useEffect } from 'react';
import { Network } from '@capacitor/network';

export const isNetworkAvailable = async () => {
  try {
    const status = await Network.getStatus();
    const isConnected = status.connected && status.connectionType !== 'none';
    return isConnected;
  } catch (error) {
    console.error('Network status check failed:', error);
    return true;
  }
};

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(true); // Initialize as true by default

  useEffect(() => {
    const checkConnection = async () => {
      try {
        const isConnected = await isNetworkAvailable();
        setIsOnline(isConnected);
      } catch (error) {
        console.error('Network status check failed:', error);
        setIsOnline(true); // Fallback to assuming online on error
      }
    };

    // Add network status change listener
    const networkListener = Network.addListener('networkStatusChange', (status) => {
      console.log('Network status changed:', status);
      const isConnected = status.connected && status.connectionType !== 'none';
      setIsOnline(isConnected);
    });

    // Initial check
    checkConnection();

    return () => {
      networkListener.remove();
    };
  }, []);

  return isOnline;
};
export default useNetworkStatus;
